export const loginRouteName = 'login';
export const multiFactorLoginRouteName = 'mfa';
export const ssoLoginRouteName = 'sso-login';
export const registerRouteName = 'register';
export const forgotPasswordRouteName = 'forgot-password';
export const forgotPasswordValidateRouteName = 'forgot-password-validate-reset-password';
export const validateResetPasswordRouteName = 'validate-reset-password';
export const signupSuccessRouteName = 'signup-success';
